import OptoutFlight from './optout_flight';

export default OptoutFlight;
